var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect } from 'react';
import { Auth } from 'aws-amplify';
import { CookieStorage } from "amazon-cognito-identity-js";
var decodePayload = function (jwtToken) {
    var payload = jwtToken.split('.')[1];
    try {
        return JSON.parse(Buffer.from(payload, 'base64').toString('utf8'));
    }
    catch (err) {
        return {};
    }
};
var calculateClockDrift = function (iatAccessToken, iatIdToken) {
    var now = Math.floor(new Date().getTime() / 1000);
    var iat = Math.min(iatAccessToken, iatIdToken);
    return now - iat;
};
var ADFSLoginHelper = function (props) {
    var prefix = 'CognitoIdentityServiceProvider.' + props.clientId;
    var storage = new CookieStorage(props.cookieStorage);
    useEffect(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var authCode, body, response, json, idTokenData, accessTokenData, prefixWithUsername;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!window.location.href.includes("?code=")) return [3 /*break*/, 4];
                        authCode = window.location.href.split('?code=')[1];
                        body = "grant_type=authorization_code&client_id=" + props.clientId + "&" +
                            ("code=" + authCode + "&redirect_uri=" + props.redirectUri);
                        return [4 /*yield*/, fetch(props.cognitoUrl + "/oauth2/token", {
                                method: 'POST',
                                body: body,
                                headers: { 'Content-Type': 'application/x-www-form-urlencoded', "Accept": "application/json" }
                            })];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _a.sent();
                        idTokenData = decodePayload(json['id_token']);
                        accessTokenData = decodePayload(json['access_token']);
                        prefixWithUsername = prefix + '.' + idTokenData['cognito:username'];
                        storage.setItem(prefix + '.LastAuthUser', idTokenData['cognito:username']);
                        storage.setItem(prefixWithUsername + '.idToken', json['id_token']);
                        storage.setItem(prefixWithUsername + '.accessToken', json['access_token']);
                        storage.setItem(prefixWithUsername + '.refreshToken', json['refresh_token']);
                        storage.setItem(prefixWithUsername + '.clockDrift', calculateClockDrift(accessTokenData['iat'], idTokenData['iat']).toString());
                        window.location.replace(props.redirectUri);
                        // TODO: Remove debug info
                        Auth.currentAuthenticatedUser()
                            .then(function (user) { return console.log(user); })
                            .catch(function (err) { return console.error(err); });
                        // TODO: Remove debug info
                        Auth.currentUserInfo()
                            .then(function (user) { return console.log(user); })
                            .catch(function (err) { return console.error(err); });
                        return [3 /*break*/, 4];
                    case 3:
                        console.error("Unable to get cognito token: " + response.statusText);
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        }); })();
    }, []);
    return (React.createElement(React.Fragment, null, props.children));
};
export default ADFSLoginHelper;
//# sourceMappingURL=ADFSLoginHelper.js.map